import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const PortfolioPage = () => {
  return (
    <div>
      <Header />
      <div className="d-flex justify-content-center">
        <div className="alert alert-success">Coming soon!</div>
      </div>
      <Footer />
    </div>
  );
};

export default PortfolioPage;
